// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pWHmz","colMin":"styles_colMin__2nUeJ"};